import React from 'react';
import TermsTable from './TermsTable';
import StringWithLink from 'components/StringWithLink';

const Lines = ({ lines, isList = false }) => {
    let result;
    const realLines = Array.isArray(lines) ? lines : [lines];
    const generateRandomId = () => parseInt(Math.random() * 10000, 10);

    if (isList) {
        result = (
            <ul key={ `paragraph-${ generateRandomId() }` }>
                {
                    realLines.map((line, j) => {
                        let el;

                        if (Array.isArray(line)) {
                            el = <Lines key={ `list-${ generateRandomId() }` } lines={ line } isList />;
                        }
                        else {
                            el = (<li key={ `list-${ generateRandomId() }` }>{ line }</li>);
                        }

                        return el;
                    })
                }
            </ul>
        );
    }
    else {
        result = realLines.map((line, i) => {
            let el;

            if (Array.isArray(line)) {
                el = <Lines key={ `paragraph-${ i }` } lines={ line } isList />;
            }
            else if (line instanceof Object && line.type === 'withLink') {
                const { type, ...restProps} = line;
                el = <StringWithLink key={ `paragraph-${ i }` } { ...restProps } />
            }
            else if (line instanceof Object) {
                el = <TermsTable key={ `paragraph-${ i }` } id={ i } table={ line } />
            }
            else {
                el = <p key={ `paragraph-${ i }` }>{ line }</p>
            }

            return el;
        });
    }

    return result;
};

export default Lines;
